module.exports = __webpack_public_path__ + "static/media/1 32 drømte.7ef326f0.mp3";